import './CertPhone.scss';
import fnc from '../mymod/commFunction';
import Button from '../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TermsAgreementInfo from './TermsAgreementInfo';

const CertPhone = ({setIsModal, title, setIsCertOk}) => {
  const navigate = useNavigate();
  const [certNumber1, setCertNumber1] = useState('');
  const [certNumber2, setCertNumber2] = useState('');
  const [isDisabled, setIsDisabled] = useState(false); // 버튼 비활성화 상태 관리
  const [timer, setTimer] = useState(0); // 남은 시간 상태 관리

  useEffect(() => {

  }, []);

  function onSendMsg() {

    const sendPhoneNumber = process.env.REACT_APP_sendPhone;
    const billId = process.env.REACT_APP_BILL_ID;//'kuesb'
    const senderPhone = sendPhoneNumber; //'033-735-8805';
    const originalSenderPhone = senderPhone;
    
    const acaCode = fnc.getCookie_public('acaCode_find');
    const stCode = fnc.getCookie_public('stCode_find');
    const stName = fnc.getCookie_public('stName_find');
    const hp = fnc.getCookie_public('hp_find');
    const gangsaName = '';//fnc.getCookie_public('gangsaName');

    const sendDate = fnc.getNow();

    const category = '인증';
    const recivePhone = hp;// '01088906672';


    const certCode = fnc.getCertCode();
    setCertNumber1(certCode);

    const msgContent = certCode;

    // console.log({ 
    //   recivePhone, // 받는사람 (수신자 전화번호)
    //   senderPhone, // 보낸사람 (발신자 전화번호)
    //   sendDate,
    //   msgContent, //전송 메시지
    //   originalSenderPhone, //보낸사람 (원래 발신자)
    //   billId, 
    //   acaCode, 
    //   stCode,
    //   stName, //성명
    //   gangsaName, //담임
    //   category, //항목
    // }, '=======>>>');
    
    fnc.sendAxios('/kuesbSmsRoutes/insert/sms', { 
      recivePhone, // 받는사람 (수신자 전화번호)
      senderPhone, // 보낸사람 (발신자 전화번호)
      sendDate,
      msgContent, //전송 메시지
      originalSenderPhone, //보낸사람 (원래 발신자)
      billId, 
      acaCode, 
      stCode,
      stName, //성명
      gangsaName, //담임
      category, //항목
    }, (res) => {
      console.log(res, Array.isArray(res) ? 'sms' : "kuesbSmsRoutes/insert/sms");
    });
  
  }

  function onCertConfirm() {
    if (!certNumber2) {
      alert('인증번호를 넣으세요');
      return;
    }

    if (certNumber1 === certNumber2) {
        setIsCertOk(true);
        setIsModal(false);
    } else {
      alert('인증번호가 옮바르지 않습니다.');
    }

  }

  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= 6) {
      setCertNumber2(value);
    }
  };

//============================================================
  return (
    <div className='CertPhone'>

      <div className='wrap-main'>
           <p class="lbl-title">{title}</p>
      <section className='section-certPhone'>
  
        <article class="article-certPhone">      
            <p class="lbl-info">회원 휴대전화번호로 인증번호가 발송됩니다.</p>
            <input type='text' className='txt-certNumber' placeholder='인증번호입력'
              value={certNumber2} onChange={handleChange}
            ></input>
        </article>

        <article class="article-menu2">
            <Button className='btn-certNumber1 h-btn-green' disableTime={60} onClick={ onSendMsg }>인증번호 받기</Button>
            <Button className='btn-certNumber2 h-btn-red' onClick={ onCertConfirm} >인증번호 확인</Button>
        </article>


    </section>

    <section className='section-termsAgreementInfo'>
            <TermsAgreementInfo/>
    </section>


    <section class="section-menu">
            <Button className='h-btn-gray' onClick={() => setIsModal(false)}>이전으로</Button>
            {/* <Button className='h-btn-red' onClick={() => {}} >로그인</Button> */}
    </section>
    
   

    </div>
    </div>
  );
};

export default CertPhone;
